import { GenericTableFields, GenericTableField } from './generic-table-field';

export class RendicontazioneTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Emissione", "emissione", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Canale", "canale", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Riscosso", "pagato", "label", "tab-cell-10 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Debito", "debito", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sp. Not.", "notificaSpese", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Oneri", "oneri", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Altro", "altro", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Aggio", "aggio", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Pagamenti interi", "numeroInteri", "label", "tab-cell-10 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Pagamenti a rate", "numeroRate", "label", "tab-cell-10 text-center");
		this.header.push(headerField);
	}
}
